import { lazyGettext } from '@eb/lazy-gettext';
import { moment } from '@eb/date';

import { constants, formatDate } from '@eb/datetime';

const { ISO_8601_DATE_FORMAT } = constants;

const START_DATE_NAME = 'startDate';
const START_TIME_NAME = 'startTime';
const END_DATE_NAME = 'endDate';
const END_TIME_NAME = 'endTime';
const DURATION_NAME = 'duration';

export const getPrefixedStartDateName = (prefix) =>
    `${prefix}${START_DATE_NAME}`;
export const getPrefixedStartTimeName = (prefix) =>
    `${prefix}${START_TIME_NAME}`;
export const getPrefixedEndDateName = (prefix) => `${prefix}${END_DATE_NAME}`;
export const getPrefixedEndTimeName = (prefix) => `${prefix}${END_TIME_NAME}`;
export const getPrefixedDurationName = (prefix) => `${prefix}${DURATION_NAME}`;

export const DEFAULT_START_DATE = moment()
    .add(40, 'days')
    .format(ISO_8601_DATE_FORMAT);
export const DEFAULT_START_TIME = '19:00';
export const DEFAULT_END_DATE = DEFAULT_START_DATE;
export const DEFAULT_END_TIME = '22:00';
export const DEFAULT_EVENT_DURATION = 180;

export const MIN_EVENT_START_DATE = formatDate(moment());
export const MAX_EVENT_START_DATE = formatDate(
    moment(MIN_EVENT_START_DATE, ISO_8601_DATE_FORMAT).add(10, 'years'),
);

export const getDefaultDateValues = (prefix) => ({
    [getPrefixedStartDateName(prefix)]: DEFAULT_START_DATE,
    [getPrefixedEndDateName(prefix)]: DEFAULT_END_DATE,
    [getPrefixedDurationName(prefix)]: DEFAULT_EVENT_DURATION,
    displayStartDateTime: true,
    displayEndDateTime: true,
});

export const DATE_LABELS = {
    startDate: lazyGettext('Event Starts'),
    startTime: lazyGettext('Start Time'),
    endDate: lazyGettext('Event Ends'),
    endTime: lazyGettext('End Time'),
};
